// extracted by css-extract-rspack-plugin
export default {"sortingFieldsWithResult":"SortingFieldsWithResult__sortingFieldsWithResult--G4KOF"};